import { array, InferType, lazy, object, string, tuple } from 'yup';

import { UserSettings } from '../types';

export const columnsOrderSettingScheme = object({
  name: string<UserSettings.ColumnsOrderSetting>().required(),
  value: lazy((value) => {
    if (value) {
      const newEntries = Object.keys(value).reduce(
        (acc, val) => ({
          ...acc,
          [val]: array().of(tuple([string(), array().of(string())])),
        }),
        {},
      );

      return object().shape(newEntries).json().required();
    }

    return string().nullable();
  }),
});

export type ColumnsOrderSetting = InferType<typeof columnsOrderSettingScheme>;
